import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';
import { Navigate } from 'react-router-dom';
import { ORGANIZATION_TAB_FEATURE_FLAG } from '../../featureFlags/uptime';
import { OrganizationPage } from './OrganizationPage';

export function OrganizationRoute() {
  const featureFlags = useApi(featureFlagsApiRef);

  if (!featureFlags.isActive(ORGANIZATION_TAB_FEATURE_FLAG)) {
    return <Navigate to="/catalog" replace />;
  }

  return <OrganizationPage />;
}
